import React from 'react';

import { ReactComponent as AssassinSymbol } from '../assets/assassin.svg';

/**
 * Header for Assassin Tools
 */
const Header = () => (
  <div className="assassin-header">
    <div className="content-container assassin-header__row">
      <AssassinSymbol className="assassin-header__symbol" />
      <h1 className="assassin-header__title">Assassin Tools</h1>
    </div>
  </div>
);

export default Header;
